var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{attrs:{"id":"modalSearch"}},[_c('button',{staticClass:"close",on:{"click":_vm.close}},[_c('img',{attrs:{"src":require("@/assets/assets/imgs/blt-close07.svg"),"alt":""}})]),_c('ButtonTodayLowestPrice',{staticClass:"searchnavi-bnr"}),_c('NaviSerchnavi')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }